import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Paywall from './Paywall';
import { selectLive, selectPremium } from './selectors';

const mapStateToProps = createStructuredSelector({
  live_access: selectLive,
  premium_access: selectPremium,
});

export const access_control = (
  WrappedComponent,
  access_level = 'premium',
  name,
) =>
  connect(mapStateToProps)(
    class extends Component {
      render() {
        const { live_access, premium_access, ...rest } = this.props;

        const hasAccess =
          (access_level === 'premium' && (premium_access || live_access)) ||
          (access_level === 'live' && live_access);

        return (
          <Fragment>
            {hasAccess ? (
              <WrappedComponent {...rest} />
            ) : (
              <Paywall name={name} />
            )}
          </Fragment>
        );
      }
    },
  );
